import { useHistory } from 'react-router-dom'

import { MIXPANEL_PROPS } from 'utils/mixpanel'
import { isFreeTrialUsed } from 'utils/freeVersionBlock'
import { trackEvent, EVENTS } from 'utils/tracking/events-tracker'

import { fonts } from '../../../../styles/variables'
import { translate } from '../../../../utils/translation'
import { GoogleButton } from '../../../buttons/GoogleSignIn'

export const AppBannerButton = ({ user, theme }) => {
  const history = useHistory()

  const onClick = () => {
    const { search } = window.location
    trackEvent({
      event: EVENTS.PURCHASE_CLICK,
      mixpanelProperties: [
        theme.purchaseButtonLocation,
        isFreeTrialUsed()
          ? MIXPANEL_PROPS.BUTTON_CTA.values.UPGRADE
          : MIXPANEL_PROPS.BUTTON_CTA.values.START_TRIAL,
      ],
    })
    if (user?.isAnnonymous) history.push('/pricing')
    else
      history.push(`${search ? `${search}&checkout=true` : '?checkout=true'}`)
  }

  return (
    <GoogleButton
      textWrap="nowrap"
      width="auto"
      height="44px"
      fontFamily={fonts.primaryBold}
      theme="dark"
      mobileStretch
      padding="0 10px"
      hideIcon
      textTransform="uppercase"
      borderRadius="4px"
      onClick={onClick}
      boxShadow="0px 4px 8px 0px rgba(0, 0, 0, 0.08)"
    >
      {translate('claim_offer_now')}
    </GoogleButton>
  )
}
